namespace GeniuzPOS.Inventory {
    export interface IcStockApproveDisassembleRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        CallAssemDocFg?: number;
        WhsSet?: string;
        WhsItem?: string;
        ExpDate?: string;
        Remark?: string;
        SetItemCode?: string;
        SetQty?: number;
        CalDtQtyFg?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveFg?: ApproveFgSelect;
        ApproveBy?: string;
        ApproveDate?: string;
        PostFg?: PostFgStatus;
        PostDate?: string;
        CancelFg?: CancelFgstatus;
        IcStockApproveDisassembleDtList?: IcStockApproveDisassembleDtRow[];
    }

    export namespace IcStockApproveDisassembleRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockApproveDisassemble';
        export const lookupKey = 'Inventory.IcStockApproveDisassemble';

        export function getLookup(): Q.Lookup<IcStockApproveDisassembleRow> {
            return Q.getLookup<IcStockApproveDisassembleRow>('Inventory.IcStockApproveDisassemble');
        }
        export const deletePermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';
        export const insertPermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';
        export const readPermission = '2Inventory:การประกอบสินค้า:อนุมัติ:View';
        export const updatePermission = '2Inventory:การประกอบสินค้า:อนุมัติ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            CallAssemDocFg = "CallAssemDocFg",
            WhsSet = "WhsSet",
            WhsItem = "WhsItem",
            ExpDate = "ExpDate",
            Remark = "Remark",
            SetItemCode = "SetItemCode",
            SetQty = "SetQty",
            CalDtQtyFg = "CalDtQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveFg = "ApproveFg",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            PostFg = "PostFg",
            PostDate = "PostDate",
            CancelFg = "CancelFg",
            IcStockApproveDisassembleDtList = "IcStockApproveDisassembleDtList"
        }
    }
}
